import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Users, Plus, Trash2 } from "lucide-react";

export default function BorclularSection({ rec, canEdit, onChanged }) {
  const [list, setList] = useState(rec.borclular || []);
  const [f, setF] = useState({ ad: "", tc: "", rol: "borçlu" });
  const [saving, setSaving] = useState(false);

  const save = async (next) => {
    setSaving(true);
    try {
      const { data } = await api.put(`/records/${rec.id}/borclular`, { borclular: next });
      setList(data.borclular || []);
      onChanged && onChanged(data);
      toast.success("Borçlu/kefil listesi güncellendi");
    } catch (e) { toast.error(e.response?.data?.detail || "Kaydedilemedi"); } finally { setSaving(false); }
  };

  const add = () => {
    if (!f.ad.trim()) { toast.error("Ad Soyad girin"); return; }
    const next = [...list, { ad: f.ad.trim(), tc: f.tc.trim(), rol: f.rol }];
    setF({ ad: "", tc: "", rol: "borçlu" });
    save(next);
  };

  const remove = (i) => { if (!window.confirm("Bu kişi silinsin mi?")) return; save(list.filter((_, idx) => idx !== i)); };

  return (
    <div className="bg-white border border-[#E7DECC] rounded-sm mt-6" data-testid="icra-borclular">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-[#E7DECC]">
        <Users className="w-4 h-4 text-[#B8933F]" />
        <div className="kicker">BORÇLULAR / KEFİLLER</div>
        <span className="ml-1 px-2 py-0.5 rounded-sm text-xs font-semibold bg-[#B8933F]/10 text-[#B8933F]">{list.length}</span>
      </div>
      {canEdit && (
        <div className="flex flex-wrap items-end gap-3 p-4 border-b border-[#E7DECC] bg-[#F3ECDD]" data-testid="borclu-form">
          <div><label className="kicker block mb-1">AD SOYAD</label><input value={f.ad} onChange={(e) => setF({ ...f, ad: e.target.value })} data-testid="borclu-ad" className="px-3 py-2 border border-[#E7DECC] rounded-sm text-sm w-56 focus:outline-none focus:border-[#B8933F]" /></div>
          <div><label className="kicker block mb-1">TC (opsiyonel)</label><input value={f.tc} onChange={(e) => setF({ ...f, tc: e.target.value })} data-testid="borclu-tc" className="px-3 py-2 border border-[#E7DECC] rounded-sm text-sm w-40 focus:outline-none focus:border-[#B8933F]" /></div>
          <div><label className="kicker block mb-1">ROL</label><select value={f.rol} onChange={(e) => setF({ ...f, rol: e.target.value })} data-testid="borclu-rol" className="px-3 py-2 border border-[#E7DECC] rounded-sm text-sm bg-white focus:outline-none focus:border-[#B8933F]"><option value="borçlu">Borçlu</option><option value="kefil">Kefil</option></select></div>
          <button onClick={add} disabled={saving} data-testid="borclu-ekle" className="flex items-center gap-1.5 px-4 py-2 bg-[#B8933F] hover:bg-[#9C7A33] text-white rounded-sm text-sm font-medium disabled:opacity-60"><Plus className="w-4 h-4" /> Ekle</button>
        </div>
      )}
      <table className="w-full text-sm">
        <thead><tr className="border-b border-[#E7DECC] bg-[#F3ECDD]">
          <th className="px-4 py-2.5 kicker text-left">Ad Soyad</th>
          <th className="px-4 py-2.5 kicker text-left">TC</th>
          <th className="px-4 py-2.5 kicker text-left">Rol</th>
          <th className="px-4 py-2.5 kicker text-right">İşlem</th>
        </tr></thead>
        <tbody>
          <tr className="border-b border-[#E7DECC] bg-[#B8933F]/5" data-testid="borclu-asil">
            <td className="px-4 py-2 font-medium">{rec.musteri}</td>
            <td className="px-4 py-2 tabular-nums">{rec.tc_no || "-"}</td>
            <td className="px-4 py-2"><span className="px-2 py-0.5 rounded-sm text-xs font-semibold bg-[#B8933F]/10 text-[#B8933F]">Asıl Borçlu</span></td>
            <td></td>
          </tr>
          {list.length === 0 ? (
            <tr><td colSpan={4} className="px-4 py-4 text-center text-[#8C8377]" data-testid="borclu-empty">Ek borçlu / kefil yok.</td></tr>
          ) : list.map((b, i) => (
            <tr key={i} className="border-b border-[#E7DECC] last:border-0" data-testid={`borclu-row-${i}`}>
              <td className="px-4 py-2 font-medium">{b.ad}</td>
              <td className="px-4 py-2 tabular-nums">{b.tc || "-"}</td>
              <td className="px-4 py-2"><span className={`px-2 py-0.5 rounded-sm text-xs font-semibold ${b.rol === "kefil" ? "bg-[#B8933F]/10 text-[#B8933F]" : "bg-[#8C8377]/10 text-[#8C8377]"}`}>{b.rol === "kefil" ? "Kefil" : "Borçlu"}</span></td>
              <td className="px-4 py-2 text-right">{canEdit && <button onClick={() => remove(i)} data-testid={`borclu-del-${i}`} className="p-1.5 text-[#8C8377] hover:text-[#A63A3A]"><Trash2 className="w-4 h-4" /></button>}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
